import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

import Auth from '../../services/auth.service';
import ContractDebitV2 from '../../pages/applications/Contracts/ContractDebitV2';
import ContractCreditV2 from '../../pages/applications/Contracts/ContractCreditV2';
import ConnectContractDefault from '../../pages/applications/Contracts/ConnectContractDefault';
import ContractCredit from '../../pages/applications/Contracts/ContractCredit';

class WithoutLayout extends React.Component {
  state = { permissions: Auth.getPermissions() };

  routes = [
    {
      path: '/without-layout/applications/contracts-debit',
      component: (
        <Suspense fallback={<div>Loading...</div>}>
          <ContractDebitV2 />
        </Suspense>
      ),
    },
    {
      path: '/without-layout/applications/contracts-credit',
      component: (
        <Suspense fallback={<div>Loading...</div>}>
          <ContractCreditV2 />
        </Suspense>
      ),
    },
    {
      path: '/without-layout/applications/contracts/connect/default',
      component: (
        <Suspense fallback={<div>Loading...</div>}>
          <ConnectContractDefault />
        </Suspense>
      ),
    },
  ];

  render() {
    return (
      <Switch>
        {this.routes.map(el => (
          <Route exact path={el.path} key={el.path}>
            <Suspense fallback={<div>Loading...</div>}>
              {' '}
              {el.component}
            </Suspense>
          </Route>
        ))}

        <Route exact path="/without-layout"></Route>
      </Switch>
    );
  }
}
export default WithoutLayout;
